<div class="card">
	<p freud-typography fontType="smallRegular1-2" class="card__overline">
		{{ 'MY_ACCOUNT.ONSITE_SESSIONS.CARD.ADDRESS' | translate }} {{ index }}
	</p>
	<h2
		*ngIf="address?.name"
		freud-typography
		fontType="h4Semibold1-2"
		class="card__title"
	>
		{{ address.name }}
	</h2>
	<p freud-typography fontType="bodyRegular1-2" class="card__info">
		<span
			class="card__info-icon freud-icon freud-icon-building-community"
		></span>
		<span>{{ formattedAddress }}</span>
	</p>
	<p freud-typography fontType="bodyRegular1-2" class="card__info">
		<span class="card__info-icon freud-icon freud-icon-phone"></span>
		<span>{{ formattedPhone }}</span>
	</p>
	<div class="card__pricing zk-flex zk-flex-col zk-items-start md:zk-flex-row">
		<app-session-values
			type="particular"
			[particularPrice]="address.professionalAddressPayment.price"
		></app-session-values>
		<app-session-values
			type="corporate"
			[corporateTiers]="address.professionalAddressPayment.canAcceptTiers"
		></app-session-values>
	</div>
	<div class="card__actions">
		<span
			freud-tooltip
			tooltipPosition="bottom"
			[tooltipLabel]="
				'MY_ACCOUNT.ONSITE_SESSIONS.CARD.BUTTONS.EDIT' | translate
			"
			class="card__actions-tooltip"
		>
			<button
				class="card__actions-button"
				[disabled]="isLoadingEdit"
				(click)="onEditAddressClick()"
			>
				<span
					*ngIf="!isLoadingEdit"
					class="card__actions-icon freud-icon freud-icon-pencil"
				></span>
				<span
					*ngIf="isLoadingEdit"
					class="
						card__actions-icon card__actions-icon--spinning
						freud-icon freud-icon-loader
					"
				></span>
			</button>
		</span>
		<span
			freud-tooltip
			tooltipPosition="top"
			[tooltipLabel]="
				'MY_ACCOUNT.ONSITE_SESSIONS.CARD.BUTTONS.REMOVE' | translate
			"
			class="card__actions-tooltip"
		>
			<button
				class="card__actions-button"
				[disabled]="isLoadingRemove"
				(click)="onRemoveAddressClick()"
			>
				<span
					*ngIf="!isLoadingRemove"
					class="card__actions-icon freud-icon freud-icon-trash"
				></span>
				<span
					*ngIf="isLoadingRemove"
					class="
						card__actions-icon card__actions-icon--spinning
						freud-icon freud-icon-loader
					"
				></span>
			</button>
		</span>
	</div>
</div>

<freud-dialog
	[modal]="true"
	[header]="
		'MY_ACCOUNT.ONSITE_SESSIONS.MODALS.REMOVE_CONFIRMATION.TITLE' | translate
	"
	[(visible)]="isConfirmModalVisible"
>
	<p>
		{{
			'MY_ACCOUNT.ONSITE_SESSIONS.MODALS.REMOVE_CONFIRMATION.DESCRIPTION'
				| translate
		}}
	</p>
	<ng-container freudTemplatefooter>
		<freud-button
			[loading]="isLoadingRemove"
			color="secondary"
			(click)="isConfirmModalVisible = false"
		>
			{{
				'MY_ACCOUNT.ONSITE_SESSIONS.MODALS.REMOVE_CONFIRMATION.CANCEL'
					| translate
			}}
		</freud-button>
		<freud-button [loading]="isLoadingRemove" (click)="removeAddress()">
			{{
				'MY_ACCOUNT.ONSITE_SESSIONS.MODALS.REMOVE_CONFIRMATION.ACCEPT'
					| translate
			}}
		</freud-button>
	</ng-container>
</freud-dialog>

<freud-dialog
	[modal]="true"
	[header]="'MY_ACCOUNT.ONSITE_SESSIONS.MODALS.WARNING.TITLE' | translate"
	[(visible)]="isWarningModalVisible"
>
	<ul class="warning-modal__list">
		<li>
			<p>
				{{
					'MY_ACCOUNT.ONSITE_SESSIONS.MODALS.WARNING.DESCRIPTION_01' | translate
				}}
			</p>
		</li>
		<li>
			<p>
				{{
					'MY_ACCOUNT.ONSITE_SESSIONS.MODALS.WARNING.DESCRIPTION_02' | translate
				}}
			</p>
		</li>
		<li>
			<p>
				{{
					'MY_ACCOUNT.ONSITE_SESSIONS.MODALS.WARNING.DESCRIPTION_03' | translate
				}}
			</p>
		</li>
	</ul>
	<ng-container freudTemplatefooter>
		<freud-button
			[loading]="isLoadingRemove"
			color="secondary"
			(click)="isWarningModalVisible = false"
		>
			<span *ngIf="warningModalType === 'edit'">{{
				'MY_ACCOUNT.ONSITE_SESSIONS.MODALS.EDIT_CONFIRMATION.CANCEL' | translate
			}}</span>
			<span *ngIf="warningModalType === 'remove'">{{
				'MY_ACCOUNT.ONSITE_SESSIONS.MODALS.REMOVE_CONFIRMATION.CANCEL'
					| translate
			}}</span>
		</freud-button>
		<freud-button
			[loading]="isLoadingRemove"
			(click)="warningModalType === 'edit' ? goToEditPage() : removeAddress()"
		>
			<span *ngIf="warningModalType === 'edit'">{{
				'MY_ACCOUNT.ONSITE_SESSIONS.MODALS.EDIT_CONFIRMATION.ACCEPT' | translate
			}}</span>
			<span *ngIf="warningModalType === 'remove'">{{
				'MY_ACCOUNT.ONSITE_SESSIONS.MODALS.REMOVE_CONFIRMATION.ACCEPT'
					| translate
			}}</span>
		</freud-button>
	</ng-container>
</freud-dialog>
